import axiosInstance from "./axiosInstance";
import { BASE_URL } from "../constants/applicationConfig";

const BASE_URL_SHOPPING_LIST = `${BASE_URL}/api/shopping-list`;

export class ShoppingListParsingApi {
  static async parseShoppingListText(text) {
    return (
      await axiosInstance.post(`${BASE_URL_SHOPPING_LIST}/ai-parse`, { text })
    ).data;
  }
}
